import ErrorContainer from "./ErrorContainer";

export default ErrorContainer;
